<template>
  <div class="footer" v-if="fotlist!=''">
    <div class="fottom main">
      <div class="fot">
        <div class="s_left">
          <div class="fots" v-for="(item,index) in fotlist" :key="index">
            <div class="sle_top">
              <p @click="topath(item.modul_id,item.id,index)">{{item.name}}</p>
              <img @click="meunOpen(index)" v-if="item.son.length>0" src="../../assets/img/jia.png" alt="">
            </div>
            <div class="sle_bot" v-if="item.son.length>0&&menuOpenindex==index">
              <div class="sle_botlist"  v-for="(itemMsg,indexMsg) in item.son" :key="indexMsg" @click="topath(itemMsg.modul_id,itemMsg.id,index)"> {{itemMsg.name}}</div>
            </div>
          </div>
        </div>
        <div class="botflex">
          <div class="dibiao">
            <div class="ditext">{{xinxilist.company_name}} &nbsp;<br>ICP:{{xinxilist.web_beian}}</div>
            <div class="ditext">Company Address:{{xinxilist.company_address}}</div>
            <div style="width: 100%;height:1px;"></div>
            <div class="ditext">Company telephone：{{xinxilist.company_phone}}</div>
            <div class="ditext">
              <img class="beian" src="../../assets/img/beian.png" alt="">
              {{xinxilist.web_copyright}} </div>
            <div class="yibiao" @click="toguan">
              <img src="../../assets/img/home.png" alt="">
              <p>Huizhong Website</p>
            </div>
          </div>
          <div class="erwima" v-if="xinxilist.weixin_path">
            <div class="erwi">
              <img :src="Baseurl+xinxilist.weixin_path" alt="">
            </div>
            <p>
              Follow us <br>for more information
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fotlist:[],//导航列表
      xinxilist:[],//底部信息
      menuOpenindex:99,
    };
  },
  inject: ["reload"],
  created() {
    setTimeout(()=>{
      this.getinfo()
    },1000)
  },
  methods: {
    //去汇中仪表官网
    toguan(){
      window.open("https://en.huizhong.co/home")
    },
    //菜单展开
    meunOpen(index){
      console.log(index)
      if(this.menuOpenindex==index){
        this.menuOpenindex=99
      }else{
        this.menuOpenindex = index
      }
      
    },
    //获取底部信息
    getinfo(){
      var that = this;
      that.$axios
      .get(`${this.Baseurl}/public_footer`) 
      .then(res => {
        console.log(res)
        that.fotlist = res.data.data.Columns
        that.xinxilist = res.data.data.web_base
      }).catch(err => console.log(err));
    },
    topath(mode,id,index){
      // console.log(mode)
      // console.log(id)
      // console.log(index)
      // console.log(index)
      // return false;
      if(index==0&&mode=="Gramlist"){
        this.$router.push({name:"Contact",query:{
          id:id,
          module_id:mode
        }})
      }else{
        this.$router.push({name:mode,query:{
          id:id,
          module_id:mode
        }})
      }
      // if(index==this.fotlist.length-1){
      //   this.$router.push({name:'Contact',query:{
      //   id:id,
      //   module_id:mode
      //   }})
      // }else{
      //   this.$router.push({name:mode,query:{
      //     id:id,
      //     module_id:mode
      //   }})
      // }
      localStorage.setItem("navIndex",index)
      this.reload()
    },
  },
};
</script>
<style scoped>
  .yibiao{
    width: 33vw;
    height: 6vw;
    margin-top: 3vw;
    background-color: #b7b7b7;
    border-radius: 2vw;
    display: flex;
    align-items: center;
  }
  .yibiao img{
    width: 3.400vw;
    height: 3.400vw;
    margin-left: 2vw;
    margin-right: 2vw;
    display: block;
  }
  .yibiao p{
    font-size: 2.8vw;
    color: #d1211b;
  }
.footer{
  width: 100%;
  background-color: #5b5b5b;
  padding-top: 2vw;
  padding-bottom: 3.333vw;
}
.fottom{
  box-sizing: border-box;
}

.botflex{
  display: flex;
}
.erwima{
  width: 16.267vw;
  margin-left: auto;
  margin-top: 8vw;
}
.erwima p {
  color: #fff;
  font-size: 2.5vw;
  text-align: center;
  margin-top: 1.5vw;
  line-height: 3.5vw;
}
.erwima .erwi{
  width: 16.267vw;
  height: 16.267vw;
}
.erwi img{
  width: 100%;
  height: 100%;
}

.fots .sle_top {
  font-size: 3.5vw;
  color: #cdcdcd;
  line-height: 11.2vw;
  display: flex;
  align-items: center;
  border-bottom: 0.133vw solid #666666;
  height: 11.2vw;
}
.fots .sle_top img{
  width: 3.133vw;
  height: 3.133vw;
  display: block;
  margin-left: auto;
  margin-right: 3vw;
}
.sle_bot{
  margin-top: 10px;
}
.sle_bot .sle_botlist{
  font-size: 3vw;
  line-height: 4vw;
  color: #c4c4c4;
  padding: 2vw 4.333vw;
  box-sizing: border-box;
}

.dibiao{
  font-size: 3.2vw;
  color: #b4b4b4;
  line-height: 5vw;
  margin-top: 5vw;
  display: flex;
  flex-wrap: wrap;
  width: 70vw;
}
.beian{
  width: 2.600vw;
  height: 2.867vw;
}
.dibiao .ditext{
  margin-right: 10px;
}
</style>